export enum TagType {
  custom = 0,
  competition = 1,
  season = 2,
  gameMode = 3,
  gameDuration = 4,
}

export interface ITag {
  type: TagType;
  value: string;
}

export namespace TagType {
  export function toString(tagType: TagType) {
    switch (tagType) {
      case TagType.gameMode:
        return "Mode";
      case TagType.season:
        return "Season";
      case TagType.competition:
        return "Competition";
      case TagType.custom:
        return "Custom";
      case TagType.gameDuration:
        return "Duration";
    }
  }

  export function prefix(tagType: TagType) {
    switch (tagType) {
      case TagType.gameMode:
        return "Mode";
      case TagType.season:
        return "Season";
      case TagType.competition:
        return "Competition";
      case TagType.gameDuration:
        return "Duration";
      // no prefix
      case TagType.custom:
        return "";
    }
  }
}

export namespace ITag {
  export function toString(tag: ITag) {
    const prefix = TagType.prefix(tag.type);
    return prefix?.length > 0 ? `${prefix}: ${tag.value}` : tag.value;
  }

  export function isSubsetOf(tags1: ITag[], tags2: ITag[]): boolean {
    const tags1Reduced = (tags1 || []).reduce(
      (prev, tag) => ({
        ...prev,
        [tag.type]: [...(prev[tag.type] || []), tag.value],
      }),
      {},
    );
    const tags2Reduced = (tags2 || []).reduce(
      (prev, tag) => ({
        ...prev,
        [tag.type]: [...(prev[tag.type] || []), tag.value],
      }),
      {},
    );

    for (const tagType of Object.keys(tags2Reduced)) {
      if (!(tagType in tags2Reduced)) return false;
      const tags1TypeSet = new Set(tags1Reduced[tagType]);
      if (!tags2Reduced[tagType].every((val) => tags1TypeSet.has(val)))
        return false;
    }

    return true;
  }
}
